import Header from './Header';
import { Outlet } from 'react-router-dom';
// 1. Importa Helmet dalla libreria react-helmet-async
import { Helmet } from 'react-helmet-async';


export default function LayoutRoute() {

  return (
    <>
      <Helmet>

        <title>Nicolò Parmiggiani | Web Developer Portfolio</title>
        
        <meta name="description" content="Portfolio di Nicolò Parmiggiani, sviluppatore front-end e back-end. Esplora i miei progetti per vedere le mie competenze in azione." />
        
        <link rel="canonical" href="https://www.nicoloparmiggiani.it/" /> 

        {/* --- META TAG PER I SOCIAL */}
        <meta property="og:title" content="Nicolò Parmiggiani - Web Developer Portfolio" />
        <meta property="og:description" content="Portfolio di Nicolò Parmiggiani, sviluppatore front-end e back-end. Esplora i miei progetti per vedere le mie competenze in azione." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.nicoloparmiggiani.it/" />
        <meta property="og:image" content="https://www.nicoloparmiggiani.it/foto/Copertina_social.jpg" />

      </Helmet>

      <Header/>
      <Outlet/>
    </>
  )
}
